"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareConnectionPayload = void 0;
var prepareConnectionPayload = function (connectionValues, isDescriptionSame) {
    if (isDescriptionSame === void 0) { isDescriptionSame = true; }
    var values = __assign({}, connectionValues);
    // copy left description to the right side as well when its needed to be the same
    if (isDescriptionSame && connectionValues.leftDescription) {
        values = __assign(__assign({}, values), { rightDescription: connectionValues.leftDescription });
    }
    // make sort order null when it isnt a number
    if ('number' !== typeof values.leftSortOrder) {
        values.leftSortOrder = null;
    }
    if ('number' !== typeof values.rightSortOrder) {
        values.rightSortOrder = null;
    }
    if ('number' !== typeof values.videoSegmentId) {
        values.videoSegmentId = parseInt(values.videoSegmentId, 10) || null;
    }
    if ('' === values.dateFrom) {
        values.dateFrom = null;
    }
    if ('' === values.dateTo) {
        values.dateTo = null;
    }
    return values;
};
exports.prepareConnectionPayload = prepareConnectionPayload;
